import { Progress } from '@s-group/design-system-components/Progress/Progress'

export const ProgressBar = ({ progress, ariaLabel }: { progress: number; ariaLabel: string }) => {
  return <Progress aria-label={ariaLabel} type="bar" value={progress} />
}
